import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getSalesReportLoading: false,
  getSalesReportFailed: false,
  getSalesReportError: false,
  getSalesReportMessage: null,
  salesReport: [],
  sales: {
    totalRecords: 0,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_SALES_REPORT_LOADING: {
      return {
        ...state,
        getSalesReportLoading: true,
        getSalesReportFailed: false,
        getSalesReportError: false,
        getSalesReportMessage: null,
        salesReport: [],
      };
    }
    case actionTypes.GET_SALES_REPORT_SUCCESS: {
      return {
        ...state,
        getSalesReportLoading: false,
        getSalesReportFailed: false,
        getSalesReportError: false,
        getSalesReportMessage: null,
        salesReport: [...action.payload.reserves],
        sales: {
          ...action.payload,
        },
      };
    }
    case actionTypes.GET_SALES_REPORT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getSalesReportLoading: false,
        getSalesReportFailed: true,
        getSalesReportError: false,
        getSalesReportMessage: message,
      };
    }
    case actionTypes.GET_SALES_REPORT_REJECT: {
      return {
        ...state,
        getSalesReportLoading: false,
        getSalesReportFailed: false,
        getSalesReportError: true,
        getSalesReportMessage: null,
      };
    }

    default:
      return state;
  }
};
